import React from 'react';
import { Chip, colors } from '@itandi/itandi-bb-ui';
import {
  DealEstimationHeader,
  statusBackgroundColors,
  statusLabel
} from '~/models/DealEstimationHeader';
import { formatDate } from '~/utils/DateUtil';

type Props = {
  dealEstimationHeader: DealEstimationHeader;
  ownManagement?: boolean;
};

export const DealEstimationHeaderStatus: React.FC<Props> = ({
  dealEstimationHeader,
  ownManagement = false
}: Props) => {
  const { status } = dealEstimationHeader;
  if (ownManagement || status === 'draft') return null;
  return (
    <>
      <Chip
        background={statusBackgroundColors(status)}
        borderColor={null}
        label={statusLabel(status)}
        maxWidth="100%"
        textColor={colors['itandi-white']}
      />
      {status !== 'request' && (
        <p>
          処理日時：
          {formatDate(dealEstimationHeader?.processedAt, true)}
        </p>
      )}
    </>
  );
};
